// extracted by mini-css-extract-plugin
module.exports = {"container":"Paper_container__Eso_e","full":"Paper_full__BMl7U","md":"Paper_md___lJjA","sm":"Paper_sm__7F_GY","containerInner":"Paper_containerInner__qRW6Q"};